import { mapKeysToVariants, theme } from '@mirohq-internal/design-system';
import { Primitive, styled } from '@miro-site/ui-styled-engine';
var attributesVariants = {
  align: {
    inherit: 'inherit',
    left: 'left',
    center: 'center',
    right: 'right'
  }
};
var variantsMap = {
  'heading-1': {
    tag: 'h1',
    type: 'heading'
  },
  'heading-2': {
    tag: 'h2',
    type: 'heading'
  },
  'heading-3': {
    tag: 'h3',
    type: 'heading'
  },
  'heading-4': {
    tag: 'h4',
    type: 'heading'
  },
  'sub-heading-1': {
    tag: 'p',
    type: 'sub-heading'
  },
  'sub-heading-2': {
    tag: 'p',
    type: 'sub-heading'
  },
  'body-text-1': {
    tag: 'p',
    type: 'body-text'
  },
  'body-text-2': {
    tag: 'p',
    type: 'body-text'
  }
};
/**
 * Base styles defined for each "type"
 */

var variantsTypesStyles = {
  heading: {
    fontFamily: 'Spoof',
    fontWeight: 'bold',
    textAlign: 'inherit',
    lineHeight: '1.2',
    fontFeatureSettings: 'normal'
  },
  'sub-heading': {
    fontFamily: 'Formular'
  },
  'body-text': {
    fontFamily: 'Formular',
    fontWeight: 400
  }
};
/**
 * Specific styles for all variants
 */

var variantsStyles = {
  'heading-1': {
    fontSize: '$400',
    upToMd: {
      letterSpacing: '-3'
    },
    fromMd: {
      fontSize: '$600',
      lineHeight: '1.15'
    },
    fromXl: {
      fontSize: '$800',
      lineHeight: '1.1'
    }
  },
  'heading-2': {
    fontSize: '$300',
    fromMd: {
      fontSize: '$500'
    },
    fromXl: {
      fontSize: '$600',
      lineHeight: '1.15'
    }
  },
  'heading-3': {
    fontSize: '$250',
    fromMd: {
      fontSize: '$400'
    }
  },
  'heading-4': {
    fontSize: '$225',
    fromMd: {
      fontSize: '$300'
    }
  },
  'sub-heading-1': {
    fontSize: '$225',
    lineHeight: '1.35',
    fontWeight: 500
  },
  'sub-heading-2': {
    fontSize: '$175',
    lineHeight: '1.15',
    fontWeight: 'bold'
  },
  'body-text-1': {
    fontSize: '$225',
    lineHeight: '1.35'
  },
  'body-text-2': {
    fontSize: '$175',
    lineHeight: '1.15'
  }
};
var TypographyStyled = styled(Primitive.p, {
  $$typographyFontColor: '$colors$font-primary',
  $$typographyLinkColor: '$colors$font-default-idle',
  color: '$$typographyFontColor',
  '&[href], & a': {
    cursor: 'pointer',
    color: '$$typographyLinkColor',
    '&:hover': {
      $$typographyLinkColor: '$colors$font-default-hover'
    },
    '&:active': {
      $$typographyLinkColor: '$colors$font-default-active'
    },
    '&:visited': {
      $$typographyLinkColor: '$colors$font-default-visited'
    },
    '&:not(:hover):not(:active)': {
      textDecoration: 'underline'
    },
    '.keyboard-a11y &:focus': {
      outline: '$border-widths$lg solid $focus-ring-default',
      borderRadius: '$50'
    }
  },
  variants: {
    offsetBottom: mapKeysToVariants(theme['space-offset'], 'offsetBottom'),
    offsetTop: mapKeysToVariants(theme['space-offset'], 'offsetTop'),
    variant: variantsStyles,
    type: variantsTypesStyles,
    // cannot use "color" because it conflicts with css attribute
    tone: {
      primary: {
        $$typographyFontColor: '$colors$font-primary'
      },
      secondary: {
        $$typographyFontColor: '$colors$font-secondary'
      },
      tertiary: {
        $$typographyFontColor: '$colors$font-tertiary',
        $$typographyLinkColor: '$colors$font-tertiary'
      }
    },
    align: {
      inherit: {
        textAlign: 'inherit'
      },
      left: {
        textAlign: 'left'
      },
      center: {
        textAlign: 'center'
      },
      right: {
        textAlign: 'right'
      }
    }
  }
});
export { attributesVariants, variantsMap, variantsStyles, variantsTypesStyles };
export default TypographyStyled;